import { router } from '@/routes/router';
import { useRoute } from 'vue-router';

function delay(milliseconds) {
    return new Promise((resolve) => {
        setTimeout(resolve, milliseconds);
    });
}

export async function error(msg) {
    toast(msg);
}

export async function showLoading() {
    document.getElementById('loadingOverlay').classList.add('show');
    document.getElementById('loadingSpanner').classList.add('show');
}

export async function hideLoading() {
    await delay(500);
    document.getElementById('loadingOverlay').classList.remove('show');
    document.getElementById('loadingSpanner').classList.remove('show');
}

export const isObjectEmpty = (obj) => Object.keys(obj).length === 0;
export const hasValidValue = (obj) =>
    Object.values(obj).some((value) => value !== '' || value !== null);

// Helper to get image path with optional new base path
export function imagePath(filename, useNewBase = false) {
    if (!useNewBase) {
        // If filename already starts with '/', return as is
        if (filename.startsWith('/')) return filename;
        return `/images/${filename}`;
    }
    // Use the new base path
    return `/my/pre-qualify/images/${filename.replace(/^\/images\//, '')}`;
}
